// extracted by mini-css-extract-plugin
export var askAiIcon = "_nf-j";
export var category = "_nf-9";
export var categoryHeader = "_nf-e";
export var container = "_nf-0";
export var group = "_nf-a";
export var groupItems = "_nf-f";
export var groupSeparator = "_nf-k";
export var loading = "_nf-1";
export var noResults = "_nf-3";
export var placeholder = "_nf-2";
export var resultContent = "_nf-5";
export var resultIcon = "_nf-c";
export var resultItem = "_nf-g";
export var resultMeta = "_nf-8";
export var resultSubtitle = "_nf-7";
export var resultSuffix = "_nf-i";
export var resultTitle = "_nf-6";
export var resultsList = "_nf-4";
export var searchGroup = "_nf-d";
export var selected = "_nf-h";
export var subgroup = "_nf-b";